import { getCurrentDate } from '../utils/dateFormatter';
import fetcher from '../modules/ajio-fetch';

const endpoints = require('../modules/ajio-util/endpoints');
// const url = 'https://10.129.49.45:9002/rilfnlwebservices/v2/rilfnl/topshopper?promotionDate=12-01-2018&winnersList=false&format=json';

const myHeaders = new Headers();

const myInit = { method: 'GET', mode: 'no-cors', headers: myHeaders };

/**
 * initiate fetch events data
 * @return {Object} [description]
 */
export const fetchEventData = () => ({
  type: 'FETCHING_EVENT_DATA'
});

/**
 * update store if fetch event fails
 * @param  {String} error [description]
 * @return {Object}       [description]
 */
export const fetchEventDataFailure = error => ({
  type: 'FETCHING_EVENT_DATA_FAILURE',
  data: error
});

/**
 * update store with reponse if fetch event responds
 * @param  {Object} data [description]
 * @return {Object}      [description]
 */
export const fetchEventDataSuccess = (data, selectedDate, winnersList) => ({
  type: 'FETCHING_EVENT_DATA_SUCCESS',
  data,
  selectedDate,
  winnersList
});

export const updateWinners = (data, winnersList) => ({
  type: 'UPDATE_WINNERS_LIST',
  data,
  winnersList
});

/**
 * [description]
 * @param  {Object} data [description]
 * @return {Object}      [update winnersList state]
 */
export const showWinners = data => ({
  type: 'SHOW_WINNERS_LIST',
  data
});

/**
 * update previous day winnerList
 */
export const updateWinnersList = (selectedDate, winnersList) => dispatch => {
  const url = `/api/leaderboard/${selectedDate}/${winnersList}?id=${Date.now()}`;
  fetcher(url)
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          if (json && json.userDetails) {
            winnersList = winnersList;
          } else {
            winnersList = !winnersList;
          }
          return dispatch(updateWinners(json, selectedDate, winnersList));
        });
      }
    })
    .catch(error => {
      dispatch(fetchEventDataFailure(json));
    });
};
/**
 * api call through node to fetch events data
 * @return {Promise} [description]
 */
// Todo : check via client side once

export const fetchData = (selectedDate, winnersList) => {
  const url = `/api/leaderboard/${selectedDate}/${winnersList}?id=${Date.now()}`;
  return fetch(url);
};

export function getEventsData(selectedDate) {
  return function(dispatch) {
    /**
     * decide if to show winners list
     */
    let winnersList;
    if (selectedDate == getCurrentDate().dateNumber && getCurrentDate().lbClosed) {
      winnersList = true;
    } else if (selectedDate == getCurrentDate().dateNumber) {
      winnersList = false;
    } else {
      winnersList = true;
    }

    dispatch(fetchEventData());

    // fetch winnersList
    if (getCurrentDate().prevDay) {
      dispatch(updateWinnersList(getCurrentDate().dateNumber - 1, true));
    }

    return fetchData(selectedDate, winnersList)
      .then(response => {
        if (response.ok) {
          response.json().then(json => {
            return dispatch(fetchEventDataSuccess(json, selectedDate, winnersList));
          });
        }
      })
      .catch(error => {
        dispatch(fetchEventDataFailure(json));
      });
  };
}
